import React from 'react';
import { Link } from 'react-router-dom';
import { FilePlus } from 'lucide-react';
import { Button } from '../../../ui/button';
import { createPageUrl } from '../../../../utils/index';

interface ApplicationListHeaderProps {
  onCreateNew?: () => void;
}

export default function ApplicationListHeader({ onCreateNew }: ApplicationListHeaderProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Aplikasi Kredit</h1>
        <p className="text-gray-500 mt-1">Kelola seluruh aplikasi kredit</p>
      </div>
      {onCreateNew ? (
        <Button onClick={onCreateNew} className="bg-blue-600 hover:bg-blue-700">
          <FilePlus className="w-4 h-4 mr-2" />
          Aplikasi Baru
        </Button>
      ) : (
        <Link to={createPageUrl('CreditSubmissionForm')}>
          <Button className="bg-blue-600 hover:bg-blue-700">
            <FilePlus className="w-4 h-4 mr-2" />
            Aplikasi Baru
          </Button>
        </Link>
      )}
    </div>
  );
}
